import React from 'react'
import Button from '@/components/Button'
import HtmlContent from '@/components/HtmlContent'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { IPropsHead } from '../interfaces'
import style from '../styles/contest_detail.module.scss'
import { usePage } from '@/hooks'

const Head = ({
  title,
  theme,
  image,
  date,
  description
}: IPropsHead): React.ReactElement => {
  const page = usePage()
  const { add_work: addWork = '/' } = page?.init_state?.global?.config
  const { object } = page?.init_state
  return (
    <Section>
      <div className={style.head}>
        <img
          src={image}
          width='415px'
          height='300px'
          alt={title}
          className={style.head__image}
        />

        <Title type='h2' theme='h1' className={style.head__title}>
          {title}
        </Title>

        {theme !== ''
          ? (
            <p className={style.head__theme}>{`Тема: ${theme}`}</p>
            )
          : null}

        <span className={style.head__date}>{date}</span>

        <Button
          href={`${addWork}?contest_id=${object.id}`}
          wide
          corner
          size='large'
          highlight
          className={style.head__button}
        >
          Участвовать
        </Button>
      </div>

      <Title type='h2' theme='h3' className={style.desc__title}>
        Описание
      </Title>

      <HtmlContent content={description} className={style.desc__text} />
    </Section>
  )
}

export default Head
